import React from 'react'
import { useNavigate } from 'react-router-dom'//React routes
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '@mui/material'

import { userActions, validationActions, notificationActions } from '../../store/actions'//Acciones para redux
import { UseImage, CustomLoadingOverlay, GenericContainer, FormDynamic, Alert } from '../../components'
import PasswordRecoveryImg from '../../assets/PasswordRecovery.jpg';
import { useTranslation } from 'react-i18next';

export const PasswordRecoveryFormComponent = (props) => {
    const { useState, useEffect } = React//Hook para el state   

    const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader 
    const [userName, setUserName] = useState('')
    const [registerPass, setRegisterPass] = useState(false)
    const [validatePIN, setValidatePIN] = useState(false)
    const [PINCapture, setPINCapture] = useState(false)
    const [reSendButton, setReSendButton] = useState(false)
    const [clickReSend, setClickReSend] = useState(false)
    const [timerSeconds, setTimerSeconds] = useState(60)
    const [cuestionaryMetadata, setCuestionaryMetadata] = useState([]);
    const { t } =  useTranslation();

    const navigate = useNavigate()//Módulo "History" de react router
    let interval = null;

    //Redux hooks
    const RegisterCPass = useSelector(state => state.RegChangePass)
    const valChangPass = useSelector(state => state.ValidateChangPass)
    const notifyChangePass = useSelector(state => state.NotificationChangePass)

    const dispatch = useDispatch()

    useEffect(() => {
        if (PINCapture) {
          setCuestionaryMetadata([
            {
              Id: "txtPIN",
              Name: "Código de seguridad",
              Description: t("security_code"),
              Required: true,
              Value: "",
              DataType: "PIN",
            },
          ]);
        } else {
          setCuestionaryMetadata([
            {
              Id: "txtUserName",
              Name: "Usuario",
              Description: t("login_user"),
              Required: true,
              Value: "",
              DataType: "Text",
            },

            {
              Id: "txtPassword",
              Name: "Nueva contraseña",
              Description: t("new_password"),
              Required: true,
              Value: "",
              DataType: "Password",
            },
          ]);
        }
    }, [PINCapture]);

    useEffect(() => {
        if (timerSeconds == 0) {
            //Activa la variable para el boton
            setReSendButton(true)
        }
        // salir cuando lleguemos a 0
        if (!timerSeconds) return;

        // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
        const intervalId = setInterval(() => {
            setTimerSeconds(timerSeconds - 1);
        }, 1000);

        // clear interval al volver a renderizar para evitar pérdidas de memoria
        return () => clearInterval(intervalId);
    }, [timerSeconds]);

    useEffect(() => {
        setLoadView(RegisterCPass?.loading)
        if (RegisterCPass.items != undefined && RegisterCPass.items != null
            && RegisterCPass.items && registerPass) {
            console.log('RegisterCPass.items: ', RegisterCPass.items)
            setPINCapture(true)
            setTimerSeconds(60)
            setReSendButton(false)
        } else if (RegisterCPass.error != undefined && RegisterCPass.error != null
            && RegisterCPass.error && registerPass) {
            Alert({
                icon: "error",
                text: RegisterCPass.error,
                okbtntext: t("general_accept"),
            });
        }
    }, [RegisterCPass])

    useEffect(() => {
        setLoadView(valChangPass?.loading)
        if (valChangPass.items != undefined && valChangPass.items != null && validatePIN) {
            console.log('valChangPass.items: ', valChangPass.items);
            navigate('/auth/');
        } else if (valChangPass.error != undefined && valChangPass.error != null
            && valChangPass.error && validatePIN) {
            Alert({
                icon: "error",
                text: valChangPass.error,
                okbtntext: t("general_accept"),
            });
        }
    }, [valChangPass])

    useEffect(() => {
        setLoadView(notifyChangePass?.loading)
        if (notifyChangePass.items != undefined && notifyChangePass.items != null && clickReSend) {
            setTimerSeconds(60)
            setReSendButton(false)
        } else if (notifyChangePass.error != undefined && notifyChangePass.error != null
            && notifyChangePass.error && clickReSend) {
            Alert({
                icon: "error",
                text: notifyChangePass.error,
                okbtntext: t("general_accept"),
            });
        }
    }, [notifyChangePass])

    //Método controlador de reenvió de pin o edición de datos
    let handleContinue = (data) => {
        console.log("Registro de usuarios", data)
        setUserName(data["txtUserName"])
        let dataRequest = {
            UserName: data["txtUserName"],
            NewPassword: data["txtPassword"]
        }
        console.log("Request user password: ", dataRequest)
        setRegisterPass(true)
        dispatch(userActions.RegisterChangePassword(dataRequest));
    }

    let handleValidatePIN = (data) => {
        let dataRequest = {
            UserName: userName,
            PIN: data["txtPIN"]
        }
        console.log('Validate pin: ', dataRequest)
        setValidatePIN(true)
        dispatch(validationActions.ValidatePINChangePassword(dataRequest));
    }

    let handleReSend = (e) => {
        let dataRequest = {
            UserName: userName,
            Tenant: ""
        }
        console.log("handleReSend---dataRequest: ", dataRequest)
        setClickReSend(true)
        dispatch(notificationActions.NotificationPINChangePassword(dataRequest));
    }

    let handleBackLogin = (e) => {
        navigate('/auth/');
    }

    //Comienza interfaz
    return (<GenericContainer>
        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
        <UseImage src={PasswordRecoveryImg}
            width={"100%"}
        />
        <Typography variant="h6" gutterBottom sx={{width: "100%", textAlign: "center"}}>{t("security_code")}</Typography>
        <Typography variant="subtitle" gutterBottom >{PINCapture ? t("enter_code")
            : t("enter_username_account")}</Typography>
       
        {PINCapture && cuestionaryMetadata?.length > 0 ?
        <>
         <Typography variant="subtitle1" gutterBottom >{t("applicant_new_code", { timerSeconds })}</Typography>
            <FormDynamic DataControls={cuestionaryMetadata}
                handleConfirm={handleValidatePIN}
                ConfirmButtonText={t("applicant_code_verification")}
                DisabledConfirm={reSendButton}
                handleCancel={handleReSend}
                CancelButtonText={t("applicant_resend_code")}
                DisabledCancel={reSendButton ? false : true}
                minHeight={"15vh"} />
                </>
            : <FormDynamic DataControls={cuestionaryMetadata}
                handleConfirm={handleContinue}
                ConfirmButtonText={"Continuar"}
                minHeight={"30vh"}
                handleCancel={handleBackLogin} />}
    </GenericContainer>)
}
